module.exports = __webpack_public_path__ + "img/tutorial_003.195cec74.png";